"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _FlexLayout = _interopRequireDefault(require("../Layouts/FlexLayout"));

var _FlexItem = _interopRequireDefault(require("../Layouts/FlexItem"));

var _CloseIcon = _interopRequireDefault(require("../Icons/CloseIcon"));

var _Paragraph = _interopRequireDefault(require("../Typography/Paragraph"));

var _ThemeManager = _interopRequireDefault(require("../../../managers/ThemeManager"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var TYPE = {
  INFO: 'info',
  ERROR: 'error',
  SUCCESS: 'success',
  WARNING: 'warning',
  SUPPLEMENTARY: 'supplementary'
};
/**
 * The Alert component is used to display alert messages.
 */

var Alert =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Alert, _React$Component);

  function Alert(props) {
    var _this;

    _classCallCheck(this, Alert);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Alert).call(this, props));

    _this.handleOnClose = function (event) {
      var onClose = _this.props.onClose;

      if (onClose) {
        onClose(event);
        return;
      }

      _this.setState({
        visible: false
      });
    };

    _this.state = {
      visible: props.visible
    };
    return _this;
  }
  /**
   * @override
   * @param {object} props - next Props
   * @param {object} state - previous state
   * @return {object|null} new state object or null
   */


  _createClass(Alert, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          type = _this$props.type,
          message = _this$props.message,
          inline = _this$props.inline,
          onClose = _this$props.onClose,
          visible = _this$props.visible,
          showCloseIcon = _this$props.showCloseIcon,
          closeIconProps = _this$props.closeIconProps,
          props = _objectWithoutProperties(_this$props, ["className", "type", "message", "inline", "onClose", "visible", "showCloseIcon", "closeIconProps"]);

      var styleProps = {
        'data-type': type,
        'data-inline': inline,
        'data-close-icon': showCloseIcon,
        'data-message-type': 'string'
      };
      var closeIconNode = showCloseIcon ? _react.default.createElement(_CloseIcon.default, _extends({
        onClick: this.handleOnClose
      }, closeIconProps)) : null;

      var messageNode = _react.default.createElement(_Paragraph.default, null, " ", message, " ");

      if (typeof message !== 'string') {
        styleProps['data-message-type'] = 'non-string';
        messageNode = message;
      }

      return !this.state.visible ? null : _react.default.createElement(_FlexLayout.default, _extends({
        className: (0, _classnames.default)(className, "".concat(_ThemeManager.default.getVar('classPrefix'), "-alert"))
      }, styleProps, props), _react.default.createElement(_FlexItem.default, {
        className: "alert-message",
        flexGrow: "1",
        alignSelf: "center"
      }, messageNode), closeIconNode);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      if (typeof props.onClose === 'function' && props.visible !== state.visible) {
        return _objectSpread({}, state, {
          visible: props.visible
        });
      }

      return null;
    }
    /**
     * Handler for onClick on the CloseIcon
     * @param {ReactEvent} event - React event.
     */

  }]);

  return Alert;
}(_react.default.Component);

exports.default = Alert;
Alert.TYPE = TYPE;
Alert.defaultProps = {
  type: TYPE.INFO,
  visible: true,
  showCloseIcon: true,
  inline: false
};
Alert.propTypes = {
  /**
   * Custom class name to be appended to the component.
   */
  className: _propTypes.default.string,

  /**
   * Message type string.  default is info
   */
  type: _propTypes.default.oneOf([TYPE.INFO, TYPE.SUCCESS, TYPE.WARNING, TYPE.ERROR, TYPE.SUPPLEMENTARY]),

  /**
   * The message string or react element.
   */
  message: _propTypes.default.node.isRequired,

  /**
   * To indicate if the alert is visible.
   */
  visible: _propTypes.default.bool,

  /**
   * Callback when user click on the Close icon.
   * NOTE: If application defined this then the expectation is the application
   * will be setting the props.visible appropriately.
   */
  onClose: _propTypes.default.func,

  /**
   * To show or hide the close icon.  When close icon is shown by default
   * the component will set the visible state to false when user click
   * on the icon.  Application can overide this behavior by handling
   * props.onClose.
   */
  showCloseIcon: _propTypes.default.bool,

  /**
   * Whether Alert should be displayed as inline variation.
   */
  inline: _propTypes.default.bool,

  /**
   * Props to pass to close icon
   */
  closeIconProps: _propTypes.default.object
};